import {
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import colors from "../../assets/theme/colors";

const menuItemSx = {
  gap: 1.1,
  py: 1.25,
  px: 1.5,
  minHeight: 48,
};

const UserAccountMenu = ({
  anchorEl,
  open,
  onClose,
  onProfile,
  onHowItWorks,
  onLogout,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    PaperProps={{
      sx: {
        mt: 1,
        minWidth: 220,
        borderRadius: "18px",
        border: `1px solid ${colors.landing.borderLight}`,
        boxShadow: `0 24px 60px ${colors.landing.shadowPanel}`,
        bgcolor: "rgba(255, 255, 255, 0.98)",
      },
    }}
  >
    <MenuItem onClick={onProfile} sx={menuItemSx}>
      <ListItemIcon sx={{ minWidth: 34 }}>
        <PersonOutlineIcon sx={{ fontSize: 18, color: colors.brand.ink }} />
      </ListItemIcon>
      My account
    </MenuItem>
    <MenuItem onClick={onHowItWorks} sx={menuItemSx}>
      <ListItemIcon sx={{ minWidth: 34 }}>
        <HelpOutlineIcon sx={{ fontSize: 18, color: colors.brand.ink }} />
      </ListItemIcon>
      How it works
    </MenuItem>
    <MenuItem onClick={onLogout} sx={menuItemSx}>
      <ListItemIcon sx={{ minWidth: 34 }}>
        <LogoutIcon sx={{ fontSize: 18, color: colors.landing.textMuted }} />
      </ListItemIcon>
      Logout
    </MenuItem>
  </Menu>
);

export default UserAccountMenu;
